import { useFeatureIsOn } from '@monofront/business/contexts';
import { FEATURE_FLAG_COBBAI_CHATBOT } from '@monofront/business/constants/featureFlags';
import useChatbotEligibility from './useChatbotEligibility';

const useIsCobbaiEnabled = (): boolean => {
  const feature = useFeatureIsOn(FEATURE_FLAG_COBBAI_CHATBOT);
  const isEligible = useChatbotEligibility();

  return isEligible && feature;
};

export default useIsCobbaiEnabled;
